import { render, staticRenderFns } from "./ITConsultancy.vue?vue&type=template&id=1fe3e654&"
import script from "./ITConsultancy.vue?vue&type=script&lang=js&"
export * from "./ITConsultancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports